import { useEffect, useState } from "react";
import { AtSign, Bell, BellRing, CalendarClock, CheckCheck, ListChecks, PhoneMissed, Users, X, AlertTriangle, CheckCircle2, RotateCcw } from "lucide-react";
import type { AppNotification } from "./types";
import { Empty } from "./ui";
import { fmtDate, fmtTime } from "./jalali";
import { enablePush, pushActive, pushSupported } from "./push";

const meta = (t: string) => {
  if (t === "mention") return { Icon: AtSign, c: "#7048e8" };
  if (t === "call_missed") return { Icon: PhoneMissed, c: "#e03131" };
  if (t.startsWith("event")) return { Icon: CalendarClock, c: "#1098ad" };
  if (t.startsWith("room")) return { Icon: Users, c: "#2f5bea" };
  if (t === "task_overdue" || t === "task_escalated") return { Icon: AlertTriangle, c: "#e03131" };
  if (t === "task_due_now" || t === "task_due_soon") return { Icon: BellRing, c: "#f08c00" };
  if (t === "task_approved" || t === "task_extension_ok") return { Icon: CheckCircle2, c: "#0ca678" };
  if (t === "task_returned" || t === "task_extension_no") return { Icon: RotateCcw, c: "#e8590c" };
  if (t.startsWith("task")) return { Icon: ListChecks, c: "#2f5bea" };
  return { Icon: Bell, c: "#5c7cfa" };
};
const when = (iso: string) => { const d = new Date(iso); return d.toDateString() === new Date().toDateString() ? fmtTime(iso) : fmtDate(iso, false) + "، " + fmtTime(iso); };

interface Props { items: AppNotification[]; unread: number; onClose: () => void; onOpen: (n: AppNotification) => void; onReadAll: () => void; onMore: () => void; hasMore: boolean }

export default function NotificationCenter({ items, unread, onClose, onOpen, onReadAll, onMore, hasMore }: Props) {
  const [only, setOnly] = useState(false); const [push, setPush] = useState<boolean | null>(null); const [msg, setMsg] = useState("");
  useEffect(() => { pushActive().then(setPush); }, []);
  const list = only ? items.filter(n => !n.is_read) : items;
  return (
    <div className="cx-drawer-wrap" onMouseDown={e => e.target === e.currentTarget && onClose()}>
      <aside className="cx-drawer">
        <div className="cx-drawer-head"><h3>اعلان‌ها{unread > 0 && <span className="cx-count">{unread}</span>}</h3><button className="cx-icon-btn" onClick={onClose}><X size={19} /></button></div>
        {pushSupported() && push === false && (
          <div className="cx-pushbanner"><BellRing size={20} /><div><b>اعلان‌ها را روی این دستگاه فعال کنید</b><small>{msg || "حتی وقتی صفحه بسته است، وظایف و پیام‌ها را فوری دریافت می‌کنید."}</small></div>
            <button className="cx-btn sm primary" onClick={async () => { const r = await enablePush(); if (r.ok) setPush(true); else setMsg(r.message || "ناموفق"); }}>فعال‌سازی</button></div>
        )}
        <div className="cx-drawer-tools row">
          <div className="cx-seg sm"><button className={!only ? "on" : ""} onClick={() => setOnly(false)}>همه</button><button className={only ? "on" : ""} onClick={() => setOnly(true)}>خوانده‌نشده</button></div>
          <button className="cx-btn sm" onClick={onReadAll} disabled={!unread}><CheckCheck size={14} /> خواندن همه</button>
        </div>
        <div className="cx-drawer-body">
          {!list.length && <Empty icon={<Bell size={26} />} title="اعلانی وجود ندارد" text="وظایف، منشن‌ها، تماس‌های بی‌پاسخ و جلسات اینجا نمایش داده می‌شوند." />}
          {list.map(n => { const { Icon, c } = meta(n.type); return (
            <button key={n.id} className={`cx-notif ${n.is_read ? "" : "unread"}`} onClick={() => onOpen(n)}>
              <span className="cx-notif-ic" style={{ background: c + "1a", color: c }}><Icon size={18} /></span>
              <div><b>{n.title}</b>{n.body && <p>{n.body}</p>}<time>{when(n.created_at)}</time></div>
              {!n.is_read && <i className="cx-unread-dot" />}
            </button>); })}
          {hasMore && !only && <button className="cx-btn block" onClick={onMore}>نمایش قدیمی‌ترها</button>}
        </div>
      </aside>
    </div>
  );
}
